module.exports = __webpack_public_path__ + "static/media/card-white.9a561bd6.svg";